import * as chatTypes from '../types/chatTypes';
import { fetchPublicChatConfig, fetchPublicKbArticles } from '../../services/chatService';

function getErrorMessage(error) {
  if (error.response?.data) {
    if (typeof error.response.data === 'string') return error.response.data;
    return error.response.data.message || error.response.data.error || 'An error occurred';
  }
  return error.message || 'An error occurred';
}

export const loadChatPublicDataAction = () => async (dispatch) => {
  dispatch({ type: chatTypes.LOAD_CHAT_PUBLIC_DATA_REQUEST });
  try {
    const [cfg, kb] = await Promise.all([fetchPublicChatConfig(), fetchPublicKbArticles()]);
    dispatch({
      type: chatTypes.LOAD_CHAT_PUBLIC_DATA_SUCCESS,
      payload: { cfg, kb },
    });
  } catch (error) {
    dispatch({
      type: chatTypes.LOAD_CHAT_PUBLIC_DATA_FAILURE,
      payload: getErrorMessage(error),
    });
  }
};

